(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectStagesService', projectStagesService);

	projectStagesService.$inject = ['$http', 'hostUrl'];

	function projectStagesService($http, hostUrl) {
		var baseUrl = '/api/2/factndx/{0}';

		return {
			addStage: addStage,
			updateStage: updateStage,
			deleteStage: deleteStage,
			updateSequence: updateSequence
		};

		function addStage(stage, siteId) {
			var url = String.format(baseUrl, siteId || globalConfig.factory.id) + '/ProjectStage';
			var newStage = {
				name: stage.name,
				code: stage.code,
				description: stage.description,
				weight: stage.weight
			};
			return $http.post(url, newStage)
				.then(addStageSuccess, handleError);

			function addStageSuccess(response) {
				return response;
			}
		}

		function updateStage(stage, siteId) {
			var url = String.format(baseUrl, siteId || globalConfig.factory.id) + '/ProjectStage/' + stage.id;
			url = addQueryParam(url, null, {
				name: stage.name,
				code: stage.code,
				description: stage.description,
				weight: stage.weight
			});
			return $http.put(url);
		}

		function deleteStage(stageId, siteId) {
			var url = String.format(baseUrl, siteId || globalConfig.factory.id) + '/ProjectStage/' + stageId;
			return $http.delete(url);
		}

		function updateSequence(stageIdSequence, siteId) {
			var url = String.format(baseUrl, siteId || globalConfig.factory.id) + '/ProjectStage/Sequence?sequence=' + stageIdSequence;
			return $http.put(url);
		}

		function handleError (error) {
			return error;
		}
	}
})();
